import React from 'react';

import CategoryTable from '../Table';

import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CategoryTable />
    </div>
  );
};
